import React, { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { StatusBadge, usePoll } from "@/components/common";

const STATUSES = ["Open", "In Review", "Waiting for Customer", "Resolved", "Closed"];

export default function AdminTickets() {
  const [tickets, setTickets] = useState([]);
  const [active, setActive] = useState(null);
  const [reply, setReply] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/tickets").then((r) => {
    setTickets(r.data);
    if (active) { const u = r.data.find((t) => t.ticket_id === active.ticket_id); if (u) setActive(u); }
  }).catch(() => {});
  usePoll(load, 6000, []);

  const send = async (status) => {
    setBusy(true);
    try { await api.post(`/admin/tickets/${active.ticket_id}/reply`, { message: reply || `Status updated to ${status}`, status }); setReply(""); load(); toast.success("Sent"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Support Tickets</h1>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="space-y-2" data-testid="admin-tickets-list">
          {tickets.length === 0 ? <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">No tickets.</div> :
            tickets.map((t) => (
              <button key={t.ticket_id} onClick={() => setActive(t)} className={`w-full text-left bg-white border rounded-2xl p-4 ${active?.ticket_id === t.ticket_id ? "border-blue-500" : "border-slate-200"}`} data-testid={`admin-ticket-${t.ticket_id}`}>
                <div className="flex items-center justify-between"><span className="font-mono text-xs text-slate-400">{t.ticket_id}</span><StatusBadge status={t.status} /></div>
                <div className="font-semibold text-slate-900 mt-1">{t.subject}</div>
                <div className="text-xs text-slate-500 mt-0.5">{t.customer_name} · {t.category}{t.order_id ? ` · ${t.order_id}` : ""}</div>
              </button>
            ))}
        </div>
        {active && (
          <div className="bg-white border border-slate-200 rounded-2xl p-5 flex flex-col" data-testid="admin-ticket-thread">
            <div className="flex items-center justify-between border-b border-slate-200 pb-3">
              <div><div className="font-semibold text-slate-900">{active.subject}</div><div className="text-xs text-slate-400 font-mono">{active.ticket_id} · {active.customer_name}</div></div>
              <StatusBadge status={active.status} />
            </div>
            {active.auto_context?.utr && (
              <div className="text-xs bg-slate-50 rounded-lg p-3 mt-3 text-slate-600">
                Expected ₹{active.auto_context.expected_inr} · Paid ₹{active.auto_context.paid_inr} · Remaining ₹{active.auto_context.remaining_inr} · UTR {active.auto_context.utr}
              </div>
            )}
            <div className="flex-1 space-y-3 mt-3 max-h-72 overflow-y-auto scrollbar-thin">
              {active.messages.map((m, i) => (
                <div key={i} className={`max-w-[85%] rounded-xl p-3 text-sm ${m.sender === "staff" ? "bg-blue-50 ml-auto" : "bg-slate-100"}`}>
                  <div className="text-xs font-semibold text-slate-500 mb-0.5">{m.name}</div>{m.message}
                  <div className="text-[10px] text-slate-400 mt-1">{new Date(m.at).toLocaleString()}</div>
                </div>
              ))}
            </div>
            <textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={2} placeholder="Reply…" data-testid="admin-ticket-reply"
              className="mt-3 w-full px-3 py-2 rounded-xl border border-slate-300 outline-none text-sm" />
            <div className="flex gap-2 mt-2 flex-wrap">
              <button onClick={() => send("Open")} disabled={busy} data-testid="admin-ticket-send" className="px-4 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold disabled:opacity-60">Reply</button>
              {STATUSES.map((s) => <button key={s} onClick={() => send(s)} disabled={busy} className="px-3 py-2 rounded-xl border border-slate-300 text-xs text-slate-600">{s}</button>)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
